<template>
        <el-dialog
                title="Capacity Utilisation Chart"
                :center="true"
                :visible.sync="dialogVisible"
                width="90%"
                @open="loadData"
        >
            <el-row>
                <div class="chart-container" v-loading="isLoadingUtilisationData">
                    <line-chart :chart-data="dataCollection" :options="options"></line-chart>
                </div>
            </el-row>
        </el-dialog>
</template>

<script>
    import { mapGetters, mapState } from 'vuex';
    import LineChart from '../charts/capacity-utilisation/StackedLineChart.js'

    const xMax = 100;
    const maxUtilisation = 80;

    export default {
        components: {
            LineChart
        },
        data () {
            return {
                dataCollection: {},
                labels: [...Array(xMax).fill("")],
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            stacked: true,
                            gridLines : {
                                display : false,
                            }
                        }],
                        yAxes: [{
                            stacked: true,
                            ticks: {
                                beginAtZero: true,
                                steps: 10,
                                max: 100
                            },
                            scaleLabel: {
                                display: true,
                                labelString: 'Capacity Utilisation %'
                            }
                        }]
                    },
                    legend: {
                        position: 'bottom',
                        align: 'center',
                    },
                },
                backgroundColors: [
                    "rgba(104, 154, 208)",
                    "rgba(223, 144, 68)",
                    "rgba(165, 165, 165)",
                    "rgba(246, 193, 66)",
                    "rgba(77, 116, 191)",
                    "rgba(126, 170, 84)",
                    "rgba(52, 95, 141)",
                ],
            }
        },
        computed: {
            ...mapState({
                utilisationData: state => state.capacityUtilisationCharts.utilisationData,
                utilisationDataLoadStatus: state => state.capacityUtilisationCharts.utilisationDataLoadStatus,
            }),
            dialogVisible: {
                get() {
                    return this.$store.state.capacityUtilisationCharts.dialogVisible
                },
                set(value) {
                    this.$store.dispatch('capacityUtilisationCharts/updateDialogVisible', value)
                }
            },
            isLoadingUtilisationData() {
                return this.utilisationDataLoadStatus === 1;
            },
        },
        methods: {
            loadData () {
                this.$store.dispatch('capacityUtilisationCharts/getUtilisationData')
                    .then(() => {
                        this.fillData();
                    }).catch(() => {
                        this.$message.error('Sorry, failed to load the utilisation data.')
                    }).then(() => {
                });
            },
            fillData () {
                const maped = this.mapRawData();
                this.dataCollection = {
                    labels: maped.labels,
                    datasets: maped.datasets,
                };
            },
            mapRawData () {
                const labels = this.labels;
                const rawData = this.utilisationData;
                const dataCollection = [];
                const totalValue = rawData.reduce((accumulator, currentValue) => {return accumulator + currentValue.value;}, 0);
                rawData.reduce((acc, data, index) => {
                    //value area
                     const xWidth = Math.round( (data.value / totalValue ) * xMax );
                     const utilisation = data.utilisation;
                     const label = data.text;
                     const colorString = this.backgroundColors[index % this.backgroundColors.length];
                     const dataPack = [...Array(acc).fill(undefined), ...Array(xWidth).fill(utilisation)];
                     const dataValue = {
                         label: label + ' $' + Math.round(data.value * data.utilisation * 0.01) + 'k',
                         fill: true,
                         backgroundColor: colorString,
                         data: dataPack,
                     };
                    dataCollection.push(dataValue);
                    //update labels
                    // labels[acc + xWidth - 1] = '$' + data.value + 'k';
                    console.log(labels);
                    //potential value area
                    const potential = Math.max(0, maxUtilisation - utilisation);
                    const dataPotentialPack = [...Array(acc).fill(undefined), ...Array(xWidth).fill(potential)];
                    const labelPotential = label + ' - Potential $' + Math.round(data.value * potential * 0.01) + 'k';
                    const dataPotential = {
                        label: labelPotential,
                        fill: true,
                        backgroundColor: this.getPotentialBackgroundColor(colorString),
                        data: dataPotentialPack,
                    };
                    dataCollection.push(dataPotential);
                    return xWidth + acc;
                }, 0);

                return {
                    labels: labels,
                    datasets: dataCollection,
                };
            },
            getPotentialBackgroundColor (colorString) {
                return colorString.split(')')[0] + ', 0.3)';
            }
        }
    }
</script>

<style>
    .small {
        max-width: 600px;
        margin:  150px auto;
    }

    .chart-container {
        position: relative;
        margin: auto;
        height: 80vh;
        width: 80vw;
    }
</style>